// Bloqueio de transportadora/serviço por empresa (Hub de Recebimentos → Roteamento de
// Pagamentos → "Transportadoras bloqueadas"). Ex.: a conta do Melhor Envio só atende a Store,
// então a Viver Organizer Ltda bloqueia "MelhorEnvio - LATAM Cargo · éFácil".
//
// A trava de verdade é o ERPApi (domain.IsCarrierBlocked → 422 na seleção da cotação, no
// pedido de envio e na emissão da NF). Aqui só se desabilita a opção para o usuário entender
// antes de tentar. Mesma regra do backend: provider_service_id null = todos os serviços.

export interface CarrierBlockRule {
  provider_id: number;
  provider_service_id: number | null;
  reason?: string;
}

export const BLOCKED_OPTION_BADGE = 'Bloqueada para esta empresa';

const DEFAULT_BLOCK_REASON = 'Transportadora/serviço bloqueado para esta empresa no roteamento de pagamentos.';

/**
 * Devolve o bloqueio que se aplica ao par (transportadora, serviço), ou null.
 * Sem serviço informado, só um bloqueio de "todos os serviços" se aplica.
 */
export const isBlockedOption = (
  blocks: readonly CarrierBlockRule[] | null | undefined,
  providerId: number | null | undefined,
  providerServiceId?: number | null,
): CarrierBlockRule | null => {
  if (!blocks || blocks.length === 0 || providerId == null) return null;
  for (const block of blocks) {
    if (block.provider_id !== providerId) continue;
    if (block.provider_service_id == null) return block;
    if (providerServiceId != null && block.provider_service_id === providerServiceId) return block;
  }
  return null;
};

/** A transportadora inteira está bloqueada (bloqueio sem serviço)? */
export const isProviderFullyBlocked = (
  blocks: readonly CarrierBlockRule[] | null | undefined,
  providerId: number | null | undefined,
): boolean =>
  !!blocks && providerId != null && blocks.some(b => b.provider_id === providerId && b.provider_service_id == null);

/** Motivo para tooltip/mensagem, com texto padrão quando a API não mandou. */
export const blockReason = (block: CarrierBlockRule | null | undefined): string =>
  (block?.reason ?? '').trim() || DEFAULT_BLOCK_REASON;

/** Cotação vinda da API com a marcação de bloqueio (campos `blocked`/`blocked_reason`). */
export interface BlockableQuote {
  blocked?: boolean;
  blocked_reason?: string | null;
}

export const isBlockedQuote = (quote: BlockableQuote): boolean => quote.blocked === true;

export const quoteBlockReason = (quote: BlockableQuote): string =>
  (quote.blocked_reason ?? '').trim() || DEFAULT_BLOCK_REASON;
